<template>
    <div id="content" v-if="!loading">
        <div class="inner">
            <h1 v-translate>Přidat konfiguraci zařízení</h1>
        </div>

        <div class="responsiveTabs">

            <ul class="tabs">
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceConfigNewProperties'}"><a @click.stop="openRoute('deviceConfigNewProperties')" v-translate>Vlastnosti</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceConfigNewPlatform'}"><a @click.stop="openRoute('deviceConfigNewPlatform')" v-translate>Platforma</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceConfigNewDevice'}"><a @click.stop="openRoute('deviceConfigNewDevice')" v-translate>Zařízení</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceConfigNewPlayer'}"><a @click.stop="openRoute('deviceConfigNewPlayer')" v-translate>Přehrávač</a></li>
                <li :class="{'r-tabs-state-active' : this.$route.name === 'deviceConfigNewFunctions'}"><a @click.stop="openRoute('deviceConfigNewFunctions')" v-translate>Funkce</a></li>
            </ul>

            <router-view
                :isEditable="isEditable"
                :entity="entity"
                :deviceTypes="deviceTypes"
                :availableValues="availableValues"
                :operatorOptions="operatorOptions"
                :operatorIdComputed="operatorIdComputed"
            />

            <section class="buttons" v-if="isEditable">
                <p>
                    <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam konfigurací zařízení</router-link>
                    <input type="submit" :value="'Uložit' | translate"
                           :class="['btn']"
                           @click.prevent.stop="createEntity()">
                </p>
            </section>
        </div>
    </div>
</template>

<script>
import detailActions from "@/components/mixins/detail-actions"
import deviceConfigs from "@/components/views/deviceConfigs/mixins/deviceConfigs"

export default {
    name: "DeviceConfigNew",
    mixins: [detailActions, deviceConfigs],
    data() {
        return {
            deviceTypes: [],
            availableValues: {},
            loading: true,
        }
    },
    created(DeviceConfigService, OperatorService) {
        this.entityService = DeviceConfigService;

        if (this.$_readActionAllowedAllOrOwnAndGlobal) {
            this.operatorService = OperatorService
          this.getOperators().then(() =>{
            this.operators = [{'id': null, 'name': this.$gettext('Nenastaven')}, ...this.operators];
          });
        }

        this.getDependency().then(() => {
            this.loading = false;
        });
    },
    computed: {
        isEditable() {
            return true;
        },
    },
    methods: {
      _beforeCreateEntityActions(params) {
        if (!params.id_operator) {
          params.id_operator = this.entity.id_operator ? this.entity.id_operator : this.$_loggedUser_selectedOperatorId;
        }
        return params;
      },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/views/deviceConfigs/DeviceConfigNew.vue